import BaseHandler from "../BaseHandler";
import { InfoUpdateResponse } from "../../proto/InfoUpdate_pb";
import { toNumber } from "lodash";
import store from "../../store";
import { goToPopup } from "../../libs/services";
import { POPUP_UPDATE } from "../../constants/routes";
import { setUpdateAvailable } from "../../store/messenger/actions";

export default class HandleInfoUpdateResponse extends BaseHandler<InfoUpdateResponse> {
  handle() {
    const infoUpdateResponse = this.response.toObject();
    const updateAvailable = Boolean(infoUpdateResponse.lastVersion !== toNumber(process.env.REACT_APP_BUILD_VERSION!));
    const storeUpdateAvailable = store.getState().messenger.updateAvailable;
    if (updateAvailable) {
      goToPopup(POPUP_UPDATE);
    }
    if (!storeUpdateAvailable && updateAvailable) store.dispatch(setUpdateAvailable(true));
  }
}
